// @flow strict

import React from "react";
import { imgSrc, secondsToTarget } from "~common/utils";
import { withRouter } from "react-router-dom";
import type { RouterHistory } from "react-router-dom";
import { TOTAL_SECONDS } from "~robin-hood/utils";
import type { RegisteredStore, Equipo } from "~robin-hood/redux/store";
import { PRUEBAS } from "~robin-hood/redux/store";
import { now } from "~common/utils";
import classnames from "~common/classnames";
import styles from "./PruebaFinal.module.css";
import window from "~robin-hood/animations/window.module.css";
// $FlowFixMe[untyped-import]
import bills from "~robin-hood/animations/bills.module.scss";
import modal from "~robin-hood/components/Modal.module.css";
import { Modal } from "react-overlays";
import button from "~robin-hood/components/Button.module.css";

type Props = {
  equipo: Equipo,
  updateEquipo: (Equipo) => void,
  store: RegisteredStore,
  updateLocalStore: (store: RegisteredStore) => void,
};

const BASE = "/images/robin-hood/prueba-final";

function finalSrc(path: string): string {
  return imgSrc(BASE + path);
}

const FRAMES = [
  finalSrc("/0.png"),
  finalSrc("/1.png"),
  finalSrc("/2.png"),
  finalSrc("/3.png"),
  finalSrc("/4.png"),
  finalSrc("/5.png"),
  finalSrc("/6.png"),
  finalSrc("/7.png"),
];

const CLOSED_IMG = imgSrc("/images/robin-hood/prueba-final/CERRADA.png");
const MANILLA_IMG = imgSrc("/images/robin-hood/prueba-final/MANILLA.png");

export function PruebaFinal(props: Props): React$Node {
  const [checking, setChecking] = React.useState<boolean>(false);
  const [checked, setChecked] = React.useState<boolean>(false);
  const { equipo } = props;
  const allCorrect = PRUEBAS.every(
    (key) => equipo.pruebas && equipo.pruebas[key]?.correct
  );

  function startChecking() {
    if (!checking) {
      setChecking(true);
      if (allCorrect) {
        setTimeout(() => {
          setChecked(true);
          setChecking(true);
          if (equipo.endTime == null) {
            props.updateEquipo({ ...equipo, endTime: now() });
          }
        }, 4000);
      } else {
        setTimeout(() => {
          setChecked(true);
          setChecking(false);
          setTimeout(() => {
            setChecked(false);
          }, 3000);
        }, 2000);
      }
    }
  }

  React.useEffect(() => {
    let timeout;
    if (equipo.endTime != null) {
      timeout = setTimeout(startChecking, 500);
    }
    return () => clearTimeout(timeout);
  }, []);

  const showCorrect = allCorrect && checked;
  return (
    <React.Fragment>
      <div
        className={classnames(
          styles.pruebaFinal,
          window.scaleInBl,
          !showCorrect && styles.hide
        )}
      >
        <div
          className={classnames(styles.bombillas, checked && styles.checked)}
        >
          {PRUEBAS.map((key) => {
            const correct = equipo.pruebas && equipo.pruebas[key]?.correct;
            return (
              <span
                key={key}
                className={classnames(
                  styles.bombilla,
                  correct ? styles.bombillaCorrect : styles.bombillaError
                )}
              />
            );
          })}
        </div>
        <div className={styles.imgWrapper}>
          <img className={styles.puerta} src={CLOSED_IMG} />
          <img
            onClick={startChecking}
            className={classnames(
              styles.manilla,
              checking && styles.checking,
              allCorrect ? styles.correct : styles.error
            )}
            src={MANILLA_IMG}
          />
        </div>
      </div>
      <AllCorrect show={showCorrect} equipo={equipo} />
    </React.Fragment>
  );
}

type AllCorrectProps = {
  show: boolean,
  equipo: Equipo,
};
function AllCorrect(props: AllCorrectProps) {
  const [frame, setFrame] = React.useState<number>(0);
  const [showEndModal, setShowEndModal] = React.useState<boolean>(false);
  const [showBills, setShowBills] = React.useState<boolean>(false);
  const hasChangedFrame = useCompare(frame);
  const hasChangedShow = useCompare(props.show);

  React.useEffect(() => {
    let interval;
    if (props.show && (hasChangedFrame || hasChangedShow)) {
      interval = setInterval(() => {
        const idx = frame;
        if (idx < FRAMES.length) {
          setFrame(idx + 1);
        } else {
          setTimeout(() => {
            setShowEndModal(true);
          }, 3000);
          setShowBills(true);
          clearInterval(interval);
        }
      }, 300);
    }
    return () => clearInterval(interval);
  }, [props.show, frame]);
  return (
    <div
      className={classnames(
        styles.allCorrectBackground,
        props.show && styles.show
      )}
    >
      {FRAMES.map((frameSrc, idx) => {
        return (
          <img
            key={frameSrc}
            src={frameSrc}
            className={idx <= frame ? styles.showImage : undefined}
          />
        );
      })}
      {showBills && <Bills />}
      <EndMisionModal equipo={props.equipo} show={showEndModal} />
    </div>
  );
}

function useCompare<V>(val: V): boolean {
  const prevVal = usePrevious(val);
  return prevVal !== val;
}

function usePrevious<V>(value: V): V | void {
  const ref = React.useRef<V | void>();
  React.useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}

type EndModalProps = {
  show: boolean,
  equipo: Equipo,
};
type StarsProps = {
  equipo: Equipo,
};

function Stars(props: StarsProps): React$Node {
  let stars;
  if (props.equipo.startTime == null || props.equipo.endTime == null)
    return null;
  if (props.equipo.extraTimeStart == null) {
    const seconds = secondsToTarget(
      props.equipo.startTime,
      TOTAL_SECONDS,
      props.equipo.endTime
    );
    console.log("seconds", seconds);
    if (seconds > 60 * 10) {
      stars = 5;
    } else {
      stars = 4;
    }
  } else {
    stars = 3;
  }
  return (
    <div className={styles.stars}>
      <span className={classnames(styles.star, "fa fa-fw fa-star")} />
      <span className={classnames(styles.star, "fa fa-fw fa-star")} />
      <span className={classnames(styles.star, "fa fa-fw fa-star")} />
      <span
        className={classnames(
          styles.star,
          "fa-fw fa-star",
          stars >= 4 ? "fas" : "far"
        )}
      />
      <span
        className={classnames(
          styles.star,
          "fa-fw fa-star",
          stars >= 5 ? "fas" : "far"
        )}
      />
    </div>
  );
}

function EndMisionModal(props: EndModalProps): React$Node {
  // Should not happen
  if (!props.equipo.startTime) {
    return null;
  }

  return (
    <Modal
      show={props.show}
      backdrop={"static"}
      onHide={() => {
        // Noop, we want to close it ourselves
      }}
      renderBackdrop={(props) => (
        <div style={{ zIndex: 0 }} className={modal.backdrop} {...props}></div>
      )}
    >
      <div className={modal.modal}>
        <div
          className={classnames(
            modal.modalContent,
            styles.endMisionModal,
            "animate__animated animate__tada"
          )}
        >
          <h1 className={classnames(modal.modalTitle, styles.modalTitle)}>
            ¡Enhorabuena equipo! ¡Misión “Robin Hood” completada con éxito!
          </h1>
          <div className={styles.starsWrapper}>
            <Stars equipo={props.equipo} />
          </div>
          <p>
            ¡Lo habéis logrado, habéis liberado todo el dinero! ¡Sois unos
            cracks!
          </p>
          <p>
            Además, habéis conseguido un <b>5€ de descuento</b> en cualquiera de nuestros juegos de Escape
            Room imprimibles. Para
            canjearlo solo necesitáis guardar el código de vuestro equipo{" "}
            <b>{props.equipo.id}</b> y presentarlo antes de efectuar el pago.
            <span className={classnames("fa fa-asterisk", styles.extra)}></span>
          </p>
          <p>
            ¡Esperamos que hayáis disfrutado jugando nuestra primera Escape Room
            online! Si os ha gustado y queréis dejarnos cualquier recomendación
            u opinión, podéis hacerlo a través de{" "}
            <a
              className={styles.google}
              target="_blank"
              rel="noopener noreferrer"
              href="https://g.page/el-gato-encerrado-escape-rooms-a/review?kd"
            >
              <b>Google</b>
            </a>
            ,{" "}
            <a
              className={styles.facebook}
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.facebook.com/elgatoencerrado.escaperoom.sevilla/reviews/"
            >
              <b>Facebook</b>
            </a>{" "}
            o directamente a nuestro email{" "}
            <b>elgatoencerrado.escape@gmail.com</b>, o apoyar nuestro trabajo
            invitándonos a un café.
          </p>
          <p className={styles.small}>
            *Condiciones: 5€ de descuento en cualquiera de nuestros juegos de Escape Room imprimibles.
            Oferta no acumulable.
          </p>
          <div className={modal.modalSubmit}>
            <BuyMeACoffee />
            <FinalizarMision />
          </div>
        </div>
      </div>
    </Modal>
  );
}
function FinalizarMisionFn({
  history,
}: {
  history: RouterHistory,
}): React$Node {
  return (
    <div className={classnames(styles.right)}>
      <a
        href="https://el-gato-encerrado.com"
        className={classnames(button.button, button.alt)}
      >
        Finalizar Misión
      </a>
    </div>
  );
}
export const FinalizarMision: React$ComponentType<{}> = withRouter(
  FinalizarMisionFn
);

function Bills() {
  const times = [..."0".repeat(4 * 10)];
  return (
    <div className={classnames(styles.bills, bills.fallingBills)}>
      {times.map((_, idx) => (
        <span key={idx.toString()} className={styles.bill}></span>
      ))}
    </div>
  );
}

export function BuyMeACoffee(): React$Node {
  const formRef = React.useRef<HTMLFormElement | null>(null);
  return (
    <div className={styles.buyMeCoffee}>
      <div
        className={styles.bmcButton}
        onClick={() => {
          if (formRef.current) {
            formRef.current.submit();
          }
        }}
      >
        <img
          className={styles.coffee}
          src={finalSrc("/coffee.svg")}
          alt="Invítanos a un café"
        />
        <form
          action="https://www.paypal.com/cgi-bin/webscr"
          method="post"
          target="_blank"
          rel="noopener noreferrer"
          ref={formRef}
        >
          <input type="hidden" name="cmd" value="_s-xclick" />
          <input type="hidden" name="hosted_button_id" value="FNL6W664VJZCA" />
          <input
            type="image"
            src=""
            border="0"
            name="submit"
            style={{ display: "none" }}
            title="PayPal - The safer, easier way to pay online!"
            alt="Botón Donar con PayPal"
          />
          <img
            alt=""
            border="0"
            src="https://www.paypal.com/es_ES/i/scr/pixel.gif"
            width="1"
            height="1"
          />
        </form>
        <span className={styles.bmcLabel}>Invítanos a un café</span>
      </div>
    </div>
  );
}
